<template>
  <div class='moduel_input' style="vertical-align: middle">
    <span style="color:red;"  v-if="moduel.required==1">*</span>
    <span class="demonstration" style="vertical-align: middle">{{moduel.name}}</span>
    <el-select
      v-model="options"
      filterable
      default-first-option
      :filter-method="filenameInput"
      @change="nameSelected"
      @remove-tag="removeUser"
      placeholder="请输文件名搜索" :disabled='disabled'>
      <el-option
        v-for="item in user_list"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>
<style scoped>
  .el-input{
    width:auto!important;
  }
</style>
<script>
  // import store from '@/vuex/store.js';
  export default {
    name: 'selectObj',
    data () {
      return {
        options: '',
        staff:'',
        keyword:'',
        user_list:[],
        disabled:false,
        web_token:'',
        web_url:''
      }
    },
    // store,
    props: ['moduel','projectData'],
    methods:{
      filenameInput:function(query){
        // if(query == ''){
        //   this.user_list = [];
        //   return false;
        // }
        this.$http.post(this.web_url+'/file',{web_token:this.web_token,keyword:query},{emulateJSON:true}).then(function(res){
          // console.log(this.templates);
          if(res.data.status == 'ok'){
            this.user_list = res.data.data;
            //                console.log(this.user_list )
          }else {

          }
        })
          .catch(function(res1){
            console.log(res1);
          });
      },
      nameSelected:function (name) {
        if(this.moduel.key_name == 'file_id'){
          this.$emit('listenToChildEvent');
        }
        this.$emit('input', this.options);
      },
      clear(){
        this.options = '';
      },
      removeUser(){
        this.$emit('input', this.options);
      }
    },
    created() {
    this.web_token = sessionStorage.getItem('web_token');
    this.web_url =  sessionStorage.getItem('web_url');

      this.filenameInput('');
      if(this.projectData[this.moduel.key_name] != ''){
        this.options = this.projectData[this.moduel.key_name];
        this.disabled = true;
      }
    },
    computed: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/filelist.vue